import type { SVGProps } from 'react';
const SvgCompassCalibration = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#compass_calibration_svg__a)">
      <path d="M12 21a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM12 10.07c1.95 0 3.72.79 5 2.07l5-5C19.44 4.59 15.9 3 12 3 8.1 3 4.56 4.59 2 7.15l5 5a7.06 7.06 0 0 1 5-2.08Z" />
    </g>
    <defs>
      <clipPath id="compass_calibration_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCompassCalibration;
